/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetOrdersResponse } from '../entities/GetOrdersResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { serviceOrderDTOSchema } from './service/orderDTOSchema'
import { z } from 'zod'

export const getOrdersResponseSchema = z.object({
  orders: z.array(z.lazy(() => serviceOrderDTOSchema)),
  total: z.number().int(),
}) as unknown as ToZod<GetOrdersResponse>